import _ from "../../../../lib/lodash.custom.min";
import {HotelOrderResult, HotelSortButton} from "../../../../app/hotelOrder";
import mapDef from "./map-def";

const helper = {
	currentArrival: currentArrival,
	currentCountry: currentCountry,
	currentDuration: currentDuration,
	arrivalAll: arrivalAll,
	date: currentDate,
	dateAndDuration: currentDateAndDuration,
	budget: currentBudget,
	depAirport: currentAirport,
	flight: currentFlight,
	hotel: currentHotel,
	kodawari: currentKodawari,
	tripAdvisorURL: tripAdvisorURL,
	getMapData: getMapData,
	getCityData: getCityData,
	getRegionData: getRegionData,
	currentArrivalLayer: currentArrivalLayer,
	pageRange: pageRange,
	calcMaxPage: calcMaxPage,
	checkStatus: checkStatus,
	isEnableToAddDest: isEnableToAddDest,
	isEnableHotelOrder: isEnableHotelOrder,
	hotelCheckBox: hotelCheckBox,
	compareParams: compareParams,
	adjustCassetteSpace: adjustCassetteSpace
};
export default helper;

function arrivalAll(store) {
	const region0 = store.state.region0;
	const country0 = store.state.country0;
	const city0 = store.state.city0;
	const country1 = store.state.country1;
	const city1 = store.state.city1;
	let area0;
	const area0code = ((area0 = "city") && city0) ||
			((area0 = "country") && country0) ||
			((area0 = "region") && region0) || null;
	let area1;
	const area1code = ((area1 = "city") && city1) ||
			((area1 = "country") && country1) || null;
	if (!area0code) return "指定なし";

	const key0 = `${area0}_code`;
	const currentArea0 =  _.find(store.def[area0], {[key0]: area0code});
	const currentArea0Name = currentArea0 ? currentArea0[`${area0}_name`] : null;

	const key1 = `${area1}_code`;
	const currentArea1 =  _.find(store.def[area1], {[key1]: area1code});
	const currentArea1Name = currentArea1 ? currentArea1[`${area1}_name`] : null;

	return _.compact([currentArea0Name, currentArea1Name]).join("、");
}

function checkStatus(selectedList, target, count) {
	return _.includes(selectedList, target) ? "checked" :
				+count > 0 ? "" :
				"disabled";
}

function currentArrival(store, level) {
	var current, city, country, region;
	if (level === 1) {
		city = store.state.city1;
		country = store.state.country1;
	} else {
		city = store.state.city0;
		country = store.state.country0;
		region = store.state.region0;
	}

	if (city) {
		current = _.find(store.def.city, {city_code: city});
		return current ? current.city_name : "指定なし";
	} else if (country) {
		current = _.find(store.def.country, {country_code: country});
		return current ? current.country_name : "指定なし";
	} else if (region) {
		current =  _.find(store.def.region, {region_code: region});
		return current ? current.region_name : "指定なし";
	} else {
		return "指定なし";
	}
}

function currentBudget(store) {
	return !_.isEmpty(store.state.budget) || categorySelected(store, ["割引"]);
}

function currentCountry(store, level) {
	var country = (level === 1) ?
			store.state.country1:
			store.state.country0;

	var current =  _.find(store.def.country, {country_code: country});
	return current ? current.country_name : "";
}

function currentDuration(store) {
	if (!store.state.duration) return "指定なし";
	let texts =  store.state.duration.map((code) => {
		const obj = _.find(store.def.duration, {code: +code});
		return obj.name;
	});
	if (texts.length > 2) {
		texts = texts.slice(0, 2);
		texts.push("...");
	}
	return texts.length > 0 ? texts.join("、") : "指定なし";
}

function currentSelectedCategories(store) {
	var selectedKodawariIds = store.state.kodawari || [];
	var selectedCategories = [];
	_.each(selectedKodawariIds, function(selectedId) {
		_.each(store.state.ConditionState.attributeId, function(attributeId, idx) {
			if (selectedId === attributeId) {
				selectedCategories.push(store.state.ConditionState.attributeCategory[idx]);
			}
		});
	});
	return selectedCategories;
}

function categorySelected(store, targets) {
	var categories = currentSelectedCategories(store);
	var isSelected = false;
	_.each(targets, function(category) {
		if(_.includes(categories, category)) {
			isSelected = true;
			return false; //break;
		}
	});
	return isSelected;
}

function currentAirport(store) {
	var depAirport = _.find(store.def.depAirport, {code: store.state.depAirport});
	return depAirport ?  depAirport.name : "指定なし";
}

function currentFlight(store) {
	return categorySelected(store, ["フライト条件"]);
}

function currentHotel(store) {
	return !!store.state.hotelname ||
			!_.isEmpty(store.state.checkedHotel) ||
			categorySelected(store, ["ホテル条件", "ホテル立地", "部屋タイプ"]);
}

function currentKodawari(store) {
	return categorySelected(store, ["ツアー内容", "観光スポット", "目的・テーマ", "そのほか"]);
}

function yyyymmddToStr(yyyymmdd) {
	return [
		yyyymmdd.slice(0, 4),
		yyyymmdd.slice(4, 6),
		yyyymmdd.slice(6, 8)
	].join("-");
}

function dowToStr(dowIndex) {
	return ["日","月","火","水","木","金","土"][Number(dowIndex)];
}

function currentDate(store) {
	if (store.state.date && !store.state.monthIsSelected) {
		var datestr = yyyymmddToStr(store.state.date);
		var dateInfo = store.def.calendarHash[datestr];
		return {
			year: dateInfo.year,
			month: dateInfo.month,
			date: dateInfo.date,
			dow: dowToStr(dateInfo.dow),
			text: dateInfo.year + "年" + dateInfo.month + "月" + dateInfo.date + "日"
		};
	} else if(store.state.monthIsSelected) {
		const yyyymm = store.def.months[store.state.monthIndex].yyyymm;
		const year = Number(yyyymm.slice(0, 4));
		const month = Number(yyyymm.slice(-2));
		return {
			year: year,
			month: month,
			date: null,
			dow: null,
			text: year + "年" + month + "月" + " (日付未指定)"
		};
	} else {
		return null;
	}
}

function currentDateAndDuration(store) {
	const date = currentDate(store);
	const hasDuration = !!store.state.duration;
	const durationText = currentDuration(store);
	if (date && hasDuration) {
		return [date.text, durationText].join("／");
	} else if (hasDuration) {
		return durationText;
	} else if (date) {
		return date.text;
	} else {
		return "指定なし";
	}
}


function tripAdvisorURL(hotel) {
	return "https://www.tripadvisor.jp/WidgetEmbed-cdspropertydetail?locationId=" +
		hotel.ta_id +
		"&lang=ja&partnerId=71F959747F01495CB195C725CD2D469F&format=html&display=true";
}

function currentArrivalLayer(state, level) {
	if (level === 1) {
		return state.country1 ? "city1" : "country1";
	}
	return state.country0 ? "city0" :
		state.region0 ? "country0": "region0";
}


function getRegionData(store) {
	const mapCount = store.state.ConditionState.mapCount;
	return store.def.region.map((item) => {
		const count = mapCount[item.regionIndex - 1] || 0;
		return {
			name: item.region_name,
			code: item.region_code,
			count: count
		};
	});
}

function getMapData(store) {
	if (!store.state.region0) return;

	const regionData = mapDef[store.state.region0];
	const countryHash = regionData[regionData.length - 1];
	const countries = Object.keys(countryHash);
	const all =_.map(store.state.ConditionState.map, function(area) {
		const count = store.state.ConditionState.mapCount[area.index - 1] || 0;
		return Object.assign({count: count}, area);
	});
	const itemsInMap = all.filter((country) => (countries.indexOf(country.code) >= 0)).sort(compareName);
	const itemsOutsideOfMap = all.filter((country) => (countries.indexOf(country.code) < 0 && country.code !== "C0")).sort(compareName);
	const otherItems = all.filter((country) => (country.code === "C0"));
	return itemsInMap.concat(itemsOutsideOfMap).concat(otherItems).filter((country) => (+country.count > 0));
}

function getCityData(store, level=0) {
	const state = store.state;
	const target = (level === 0 || state.country0 === state.country1) ? 0 : 1;
	const cities = state.ConditionState[`city${target}`].slice();

	const noZero = (obj) => (+obj.count > 0);
	const overlap = (obj) => (obj.code !== state.city0);
	return level === 0 ?
			cities.filter(noZero).sort(compareName):
			cities.filter(noZero).filter(overlap).sort(compareName);
}

function compareName(a, b) {
	return (a.k_name || a.name) > (b.k_name || b.name) ? 1 : -1;
}

function pageRange(data) {
	const offset = Math.floor(data.width / 2);
	const maxPage = calcMaxPage(data.total, data.limit);
	const rangeMin = Math.max(1, data.current - offset);
	const rangeMax = Math.min(rangeMin + data.width - 1, maxPage);
	return {min: rangeMin, max: rangeMax};
}

function calcMaxPage(total, limit) {
	return Math.ceil(Number(total) / Number(limit));
}

function isEnableToAddDest(state) {
	const counts = state.ConditionState;
	if (!counts || !state.country0) return false;

	const selectableCountries = counts.mapCount.filter((v) => (Number(v) > 0));
	if (selectableCountries.length > 1) return true;

	const cities = counts.city0.concat(counts.city1);
	const selectableCities = cities.filter((o) => (Number(o.count) > 0));
	if (selectableCities.length > 1) return true;

	return false;
}

function isEnableHotelOrder(param) {
	return  HotelOrderResult.isEnable(param);
}

function hotelCheckBox(ev) {
	//検索条件を検索条件候補に入れる
	setPickedHotel(ev);
	if (ev.data.state.pickedHotel) {
		_.forEach(ev.data.state.pickedHotel, function(hotel_code) {
			let checkboxID = "#" + hotel_code;
			$(checkboxID).prop("checked", true);
			$("#popup-" + hotel_code).show();
			adjustCassetteSpace("remove", $("#" + hotel_code));
		});
	}
}

function setPickedHotel(ev) {
	const store = ev.data;
	let pickedHotel = store.state.pickedHotel ? _.uniq(store.state.pickedHotel.concat(store.state.checkedHotel)) : [];
	store.state.set({["pickedHotel"]: pickedHotel});
}

function compareParams(currentParams, lastParams) {
	return HotelSortButton.compareParams(currentParams, lastParams);
}

function adjustCassetteSpace(type, casette) {
	//カセットのクラス名を差し替えることでスペースの調整
	if (type === "remove") {
		casette.parents(".resultBox").removeClass("mgt30");
		casette.parents(".resultBox").addClass("mgt10");
	} else {
		casette.parents(".resultBox").removeClass("mgt10");
		casette.parents(".resultBox").addClass("mgt30");
	}
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/view-helper.js